export default {"src":"/_next/static/media/complete.ca961197.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};